export default "__VITE_ASSET__40d109bc__"